import { DataService } from '../../services/data.service';
import { observable, action, toJS, } from 'mobx';
import { Injectable } from '@angular/core';
import { pushToArray, pushToObject } from 'src/app/services/convert.service';
import { ACADEMIC_YEAR_STATUS, APPS, COLLECTION_NAME, PROGRAM_OPTION_OBJ } from 'src/app/dummy/app';
import { ITrending, IReadingClub, IReadingAudio, IBook } from 'src/app/interfaces/book-store';
import { academicYearObj, groupBy, MappingService } from 'src/app/services/mapping.service';
import { IReadingMember } from 'src/app/interfaces/student';
import { READING_MEMBER_OBJECT } from 'src/app/dummy/status';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable()
export class BookstoreStore {
  @observable data: any[] = [];
  @observable students: any[] = [];
  @observable groups: any[] = [];
  @observable process: boolean = false;
  @observable loading: boolean = true;
  @observable empty: boolean = false;
  @observable lastVisible: any = null;
  @observable selectedBatch: any = null;
  @observable fetching: boolean = false;

  @observable options: any[] = [];
  constructor(private ds: DataService,
    private afs: AngularFirestore,
  ) { }


  @observable fetchAcademicYearRef: any = null;
  @action
  fetchAcademicYear() {
    this.loading = true;
    this.fetchAcademicYearRef = this.ds.academicYearRef()
      .valueChanges()
      .subscribe(docs => {
        this.data = docs;
        this.loading = false;
        this.empty = docs.length === 0;
      })
  }

  @observable fetchSchoolsRef: any = null;
  @action
  fetchSchools() {
    this.loading = true;
    this.fetchSchoolsRef = this.ds.companyRef()
      .valueChanges()
      .subscribe(docs => {
        this.data = docs;
        this.loading = false;
        this.empty = docs.length === 0;
      })
  }

  @action
  async fetchBatchData(batchKey) {
    const doc = await this.ds.readingBatchRef().doc(batchKey).get().toPromise();
    this.selectedBatch = pushToObject(doc);
  }

  @action
  fetchReadingBatchStudents(batchKey) {
    this.loading = true;
    this.ds.readingBatchRef().doc(batchKey).collection("students").valueChanges().subscribe(docs => {
      this.students = docs;
      this.loading = false;
      this.empty = docs.length === 0;

    })
  }

  @action
  fetchReadingBatches() {
    this.loading = true;
    this.ds.readingBatchRef().valueChanges().subscribe(docs => {
      this.data = docs;
      this.groups = groupBy(docs, "levelKey", "level.order")
      this.loading = false;
    })
  }

  async resolveData() {
    const books = await this.ds.booksRef().get().toPromise();
    const batch = this.ds.batch();
    books.forEach(m => {
      batch.update(this.ds.firestore().collection('book_store_books').doc(m.id), {
        audiobook: false,
      })
    })
    // batch.commit().then(() => {
    // })
  }

  @action
  addNewItem(collectionName: any, item: any, callback) {
    this.process = true;
    this.ds.collection(collectionName).doc(item.key).set(item).then(() => {
      callback(true, null);
    }).catch((error) => {
      alert(error);
      callback(false, error)
    }).finally(() => {
      this.process = false;
    })
  }

  @action
  deleteMember(item: IReadingMember, callback) {
    this.process = true;
    const batch = this.ds.batch();
    const studentRef = this.ds.studentFireRef().doc(item.key);
    if (item.accountType.key === READING_MEMBER_OBJECT.teachers.key) {
      batch.delete(this.ds.userFRef(item.key))
    }
    batch.delete(studentRef)
    batch.commit().then(() => {
      callback(true, null);
    }).catch((error) => {
      alert(error);
      callback(false, error)
    }).finally(() => {
      this.process = false;
    })
  }


  @action
  deleteItem(collectionName: any, item: any, callback) {
    const batch = this.ds.batch();
    this.process = true;
    this.ds.collection(collectionName).doc(item.key).delete().then(() => {
      callback(true, null);
    }).catch((error) => {
      alert(error);
      callback(false, error)
    }).finally(() => {
      this.process = false;
    })
  }


  @action
  async fetchListArray(collectionName, orderBy) {
    const docs = await this.ds.listRef(collectionName, orderBy).get().toPromise();
    return pushToArray(docs);
  }

  @action
  async fetchCollection(collectionName, orderBy) {
    const docs = await this.ds.firestoreRef().collection(collectionName, ref => ref.orderBy(orderBy)).get().toPromise();
    return pushToArray(docs);
  }

  @action
  async fetchActivityType(key) {
    const docs = await this.ds.firestoreRef().collection(COLLECTION_NAME.ACTIVITY_TYPE).doc(key).get().toPromise();
    return pushToObject(docs);
  }

  @action
  fetchDataList(collectionName, orderBy, callback) {
    this.ds.firestoreRef().collection(collectionName, ref => ref.orderBy(orderBy)).valueChanges().subscribe(docs => {
      callback(docs)
    })
  }


  @action
  fetchList(collectionName, orderBy, callback) {
    this.ds.listRef(collectionName, orderBy).valueChanges().subscribe(docs => {
      callback(docs)
    })
  }

  @action
  fetchActivityByModule(moduleKey, activityTypeKey, organizationKey, callback) {
    this.loading = true;
    this.ds.activityByModuleRef(moduleKey, activityTypeKey, organizationKey).valueChanges().subscribe(docs => {
      this.loading = false;
      callback(docs)
    })
  }

  @action
  async fetchActivity(moduleKey, displayStatus, organizationKey: string) {
    this.lastVisible = null;
    this.loading = true;
    this.data = [];
    this.ds.activityRef(this.lastVisible, moduleKey, displayStatus, organizationKey).valueChanges().subscribe(docs => {
      this.data = docs
      this.empty = docs.length === 0;
      this.loading = false;
      if (docs.length > 0 && docs.length >= APPS.SIZE) {
        this.lastVisible = docs[docs.length - 1];
      } else {
        this.lastVisible = null;
      }
    })
  }

  @observable fetchMemberRef: any = null;
  @action
  fetchMember(accountTypeKey, appNameKey) {
    this.lastVisible = null;
    this.loading = true;
    this.data = [];
    this.fetchMemberRef = this.ds.userMemberRef(this.lastVisible, accountTypeKey, appNameKey)
      .valueChanges()
      .subscribe(docs => {
        this.data = docs
        this.empty = docs.length === 0;
        this.loading = false;
        if (docs.length > 0 && docs.length >= APPS.SIZE) {
          this.lastVisible = docs[docs.length - 1];
        } else {
          this.lastVisible = null;
        }
      });

  }
  @action
  async fetchMoreMember(accountTypeKey, appNameKey) {
    if (this.fetching || this.lastVisible === null || this.loading) { return; }
    this.fetching = true;
    const docsData = await this.ds.userMemberRef(this.lastVisible, accountTypeKey, appNameKey).get().toPromise();
    const docs = pushToArray(docsData);
    if (docs.length > 0 && docs.length >= APPS.SIZE) {
      this.lastVisible = docs[docs.length - 1];
    } else {
      this.lastVisible = null;
    }
    this.data = this.data.slice().concat(docs);
    this.fetching = false;
  }

  @observable fetchBookDataRef: any = null;
  @action
  fetchBookData(collectionName, displayStatus: any, bookTypeKey, levelKey?: any, search?: any) {
    this.lastVisible = null;
    this.loading = true;
    this.data = [];
    this.fetchBookDataRef = this.ds.bookRef(collectionName, this.lastVisible, displayStatus, bookTypeKey, levelKey, search)
      .valueChanges()
      .subscribe(docs => {
        this.data = docs
        this.empty = docs.length === 0;
        this.loading = false;
        if (docs.length > 0 && docs.length >= APPS.SIZE) {
          this.lastVisible = docs[docs.length - 1];
        } else {
          this.lastVisible = null;
        }
      });
  }

  @observable scrollBookDataRef: any = null;
  @action
  scrollBookData(collectionName, displayStatus: any, bookTypeKey, levelKey?: any) {
    if (this.fetching || this.lastVisible === null) { return }
    this.fetching = true;
    this.scrollBookDataRef = this.ds.bookRef(collectionName, this.lastVisible, displayStatus, bookTypeKey, levelKey)
      .valueChanges().subscribe(docs => {
        if (docs.length > 0 && docs.length >= APPS.SIZE) {
          this.lastVisible = docs[docs.length - 1];
        } else {
          this.lastVisible = null;
        }
        this.fetching = false;
        this.data = this.data.concat(docs)
      });

  }


  @action
  async fetchData(collectionName, displayStatus: any) {
    this.lastVisible = null;
    this.loading = true;
    this.data = [];
    this.ds.bookstoreRef(collectionName, this.lastVisible, displayStatus).valueChanges().subscribe(docs => {
      this.data = docs
      this.empty = docs.length === 0;
      this.loading = false;
      if (docs.length > 0 && docs.length >= APPS.SIZE) {
        this.lastVisible = docs[docs.length - 1];
      } else {
        this.lastVisible = null;
      }
    });

  }


  @action
  async fetchMore(collectionName, displayStatus: any) {
    if (this.fetching || this.lastVisible === null || this.loading) { return; }
    this.fetching = true;
    const docsData = await this.ds.bookstoreRef(collectionName, this.lastVisible, displayStatus).get().toPromise();
    const docs = pushToArray(docsData);
    if (docs.length > 0 && docs.length >= APPS.SIZE) {
      this.lastVisible = docs[docs.length - 1];
    } else {
      this.lastVisible = null;
    }
    this.data = this.data.slice().concat(docs);
    this.fetching = false;
  }

  @action
  fetchSelectedData(collectionName, key: any, callback) {
    this.loading = true;
    this.ds.firestoreRef().collection(collectionName).doc(key).valueChanges().subscribe(doc => {
      callback(doc)
      this.loading = false;
    })
  }

  @action
  addItem(collectionName, item: ITrending, callback) {
    this.process = true;
    const batch = this.ds.batch();
    const ref = this.ds.batchCollectionRef().collection(collectionName).doc(item.key);
    batch.set(ref, item, { merge: true });
    batch.commit().then(() => {
      callback(true, null);
    }).catch((error) => {
      alert(error);
      callback(false, error)
    }).finally(() => {
      this.process = false;
    })
  }

  @action
  updateCoverDownloadURL(item: any, downloadURL: any, fileName, callback) {
    this.process = true;
    this.ds.booksRef().doc(item.key).update({
      coverDownloadUrl: downloadURL,
      coverFileName: fileName,
    }).then(() => {
      callback(true, null);
    }).catch((error) => {
      alert(error);
      callback(false, error)
    }).finally(() => {
      this.process = false;
    })
  }

  @action
  updateSampleDownloadURL(item: any, downloadURL: any, fileName, callback) {
    this.process = true;
    this.ds.booksRef().doc(item.key).update({
      sampleDownloadUrl: downloadURL,
      sampleFileName: fileName,
    }).then(() => {
      callback(true, null);
    }).catch((error) => {
      alert(error);
      callback(false, error)
    }).finally(() => {
      this.process = false;
    })
  }

  @action
  uploadReadingBook(item: any, files, callback) {
    this.process = true;
    this.ds.collection(COLLECTION_NAME.READING_LIBRARY).doc(item.key).update({
      bookFileDetail: files
    }).then(() => {
      callback(true, null);
    }).catch((error) => {
      alert(error);
      callback(false, error)
    }).finally(() => {
      this.process = false;
    })
  }

  @action
  uploadAudioBook(item: IReadingAudio, files: any, callback) {
    this.process = true;
    const { audioFileDetail } = item;
    this.ds.collection(COLLECTION_NAME.READING_LIBRARY).doc(item.key).update({
      audioFileDetail: audioFileDetail.concat(files),
    }).then(() => {
      callback(true, null);
    }).catch((error) => {
      alert(error);
      callback(false, error)
    }).finally(() => {
      this.process = false;
    })
  }

  @action
  uploadCoverBook(item: IReadingAudio, files: any, callback) {
    this.process = true;
    const { audioFileDetail } = item;
    const docs = audioFileDetail.concat(files);
    this.ds.collection(COLLECTION_NAME.READING_LIBRARY).doc(item.key).update({
      coverFileName: docs.map(m => m.name),
      coverDownloadUrl: docs
    }).then(() => {
      callback(true, null);
    }).catch((error) => {
      alert(error);
      callback(false, error)
    }).finally(() => {
      this.process = false;
    })
  }

  @action
  updateBookDownloadURL(item: any, downloadURL: any, fileName, callback) {
    this.process = true;
    this.ds.booksRef().doc(item.key).update({
      bookDownloadUrl: downloadURL,
      bookFileName: fileName,
    }).then(() => {
      callback(true, null);
    }).catch((error) => {
      alert(error);
      callback(false, error)
    }).finally(() => {
      this.process = false;
    })
  }

  @action
  updateBookAudioDownloadURL(item: any, downloadURL: any, callback) {
    this.process = true;
    this.ds.booksRef().doc(item.key).update({
      soundDownloadURL: downloadURL,
    }).then(() => {
      callback(true, null);
    }).catch((error) => {
      alert(error);
      callback(false, error)
    }).finally(() => {
      this.process = false;
    })
  }

  @action
  async fetchBookClub() {
    return pushToArray(await this.ds.bookClubRef().get().toPromise())
  }

  @action
  addReadingBook(reading: IReadingClub, callback) {
    this.process = true;
    this.ds.generalPlacementTestRef().doc(reading.classKey)
      .collection('reading_books').doc(reading.key).set(reading)
      .then(() => {
        callback(true, null);
      }).catch((error) => {
        alert(error);
        callback(false, error)
      }).finally(() => {
        this.process = false;
      })
  }


  @action
  saveBook(reading: IBook, callback) {
    this.process = true;
    this.ds.booksRef().doc(reading.key).set(reading).then(() => {
      callback(true, null);
    }).catch((error) => {
      alert(error);
      callback(false, error)
    }).finally(() => {
      this.process = false;
    })
  }

  // @action
  // addReadingExercise(reading: IReadingExercise, callback) {
  //     this.process = true;
  //     this.ds.generalPlacementTestRef().doc(reading.classKey)
  //         .collection('reading_books').doc(reading.readingKey)
  //         .collection('reading_exercises').doc(reading.key).set(reading)
  //         .then(() => {
  //             callback(true, null);
  //         }).catch((error) => {
  //             alert(error);
  //             callback(false, error)
  //         }).finally(() => {
  //             this.process = false;
  //         })
  // }


  @action
  fetchReading(classKey) {
    this.loading = true;
    this.ds.generalPlacementTestRef().doc(classKey).collection('reading_books', ref => ref.orderBy('page_key')).valueChanges().subscribe(docs => {
      this.data = docs;
      this.empty = docs.length === 0;
      this.loading = false;
    })
  }

  @action
  fetchReadingBook(classKey, readingKey, callback) {
    this.ds.generalPlacementTestRef().doc(classKey).collection('reading_books').doc(readingKey).valueChanges().subscribe(doc => {
      callback(doc)
    })
  }

  @action
  fetchReadingExerciseDoc(classKey, readingKey, exerciseKey, callback) {
    this.ds.generalPlacementTestRef().doc(classKey)
      .collection('reading_books').doc(readingKey)
      .collection('reading_exercises').doc(exerciseKey)
      .valueChanges().subscribe(doc => {
        callback(doc)
      })
  }

  @action
  fetchReadingExercise(bookKey, callback) {
    this.loading = true;
    this.ds.booksRef().doc(bookKey).collection('exercises', ref => ref.orderBy('page_key')).valueChanges().subscribe(docs => {
      this.data = docs;
      this.empty = docs.length === 0;
      this.loading = false;
      callback(docs);
    })
  }

  @action
  async fetchBook(bookKey) {
    const doc = await this.ds.booksRef().doc(bookKey).get().toPromise();
    return doc.exists ? doc.data() : null;
  }

  @action
  delete(reading: IReadingClub, callback) {
    this.process = true;
    this.ds.generalPlacementTestRef().doc(reading.classKey)
      .collection('reading_books').doc(reading.key).delete()
      .then(() => {
        callback(true, null);
      }).catch((error) => {
        alert(error);
        callback(false, error)
      }).finally(() => {
        this.process = false;
      })
  }


  @action
  updateCoverDownload(collectionName, item: any, file, callback) {
    this.process = true;
    this.ds.collection(collectionName).doc(item.key).update({
      fileDetail: file,
    }).then(() => {
      callback(true, null);
      this.process = false;
    }).catch((error) => {
      alert(error);
      callback(false, error)
      this.process = false;
    })
  }

  @action
  updateItemDownload(collectionName, item: any, callback) {
    this.process = true;
    this.ds.collection(collectionName).doc(item.key).update(item).then(() => {
      callback(true, null);
      this.process = false;
    }).catch((error) => {
      alert(error);
      callback(false, error)
      this.process = false;
    })
  }

  @action
  async activeTerm(item: any, user: any, callback) {
    const batch = this.ds.batch();
    this.loading = true;
    const { key, termType, organizationKey } = item

    const envDoc = await this.ds.storeDocRef(organizationKey).collection("academic_environment").doc("academic_environment").get().toPromise();
    const envData = MappingService.pushToObject(envDoc)
    const { year, term } = envData
    const oldAcademicYear = termType.key === PROGRAM_OPTION_OBJ.yearBase.key ? year : term

    const schoolRef = this.ds.firestore().collection("organizations").doc(organizationKey)
    const yearRef = this.ds.academicYearFireRef()

    let data = null;
    if (termType.key === PROGRAM_OPTION_OBJ.yearBase.key) {
      data = {
        year: academicYearObj(item)
      }
    } else {
      data = {
        term: academicYearObj(item)
      }
    }

    //CLOSE ACADEMIC YEAR
    const closeData = {
      yearStatus: ACADEMIC_YEAR_STATUS[2],
      closed_at: new Date(),
      closed_by: user.key,
    }

    //NEW ACADEMIC YEAR
    batch.update(schoolRef.collection("academic_environment").doc("academic_environment"), { ...data })

    const activeData = {
      yearStatus: ACADEMIC_YEAR_STATUS[1],
      active_at: new Date(),
      active_by: user.key,
    }

    batch.update(yearRef.doc(key), { ...activeData })
    batch.update(schoolRef.collection("academic_year").doc(key), { ...activeData })

    batch.commit().then(() => {
      this.loading = false;
      callback(true, null);
    }).catch(error => {
      this.loading = false;
      callback(false, error);
    })
  }

  @observable fetchResolveDataRef: any = null;
  @action
  async fetchResolveData() {
    this.loading = true;
    const student = pushToArray(await this.ds.resolveDataRef().get().toPromise())
    this.data = student.filter((m: any) => m.accountType.key === 0)

    this.loading = false;

    // this.fetchResolveDataRef = this.ds.resolveDataRef()
    //   .valueChanges()
    //   .subscribe(docs => {
    //     console.log('docs', toJS(docs));
    //     this.data = docs.filter((m: any) => m.accountType.key === 0)
    //     // this.data = docs;
    //     console.log('docs', toJS(docs));

    //     this.loading = false;
    //     this.empty = docs.length === 0;
    //   })
  }

  @action
  async ResolveData() {
    this.loading = true;
    const student = pushToArray(await this.ds.resolveDataRef().get().toPromise())

    const free = student.filter((m: any) => m.accountType.key === 0)
    console.log('free', toJS(free));

    console.log(free.length);
    // free.forEach(async e => {
    //   if (e && e.key && e.accountType.key === 0) {
    //     const student = await this.ds.collection('students')
    //     student.doc(e.key).update({ accountType: { key: 1, router: "students", text: "Students" } })
    //     console.log('done');
    //   }
    // })


    // student.forEach(async studentDoc => {
    //   if (studentDoc && studentDoc.key) {
    //     // const { audiobook_completed, batchKey, book_completed, currentReadingLevel, licenceKey, current_book, listen_duration, licenceOption, organizationKey,
    //     //   read_duration, quiz_completed, total_audio_books, total_books, word_reads, memberCreatedDate, memberExpiredDate
    //     // }  = studentDoc
    //     const batchData = pushToObject(await this.ds.collection('reading_batches').doc(studentDoc.batchKey).get().toPromise())
    //     const historyDoc = this.ds.collection('students').doc(studentDoc.key).collection('history')

    //     // const data = {
    //     //   //reading batch data
    //     //   academicYear: {
    //     //     key: batchData.academicYear.key,
    //     //     name: batchData.academicYear.name,
    //     //     academic_year: batchData.academicYear.academic_year
    //     //   },
    //     //   batchKey: batchData.key,
    //     //   batchData: {
    //     //     key: batchData.key,
    //     //     name: batchData.name,
    //     //     level: {
    //     //       key: batchData.level.key,
    //     //       name: batchData.level.name
    //     //     }
    //     //   },
    //     //   key: studentDoc.batchKey,

    //     //   //student Data
    //     //   licenceKey: studentDoc,
    //     //   licenceOption: studentDoc.licenceOption,
    //     //   memberCreatedDate: studentDoc.memberCreatedDate,
    //     //   memberExpiredDate: studentDoc.memberExpiredDate,

    //     //   // batch activity
    //     //   audiobook_completed: studentDoc.audiobook_completed,
    //     //   book_completed: studentDoc.book_completed,
    //     //   currentReadingLevel: studentDoc.currentReadingLevel,
    //     //   current_book: studentDoc,
    //     //   listen_duration: studentDoc.listen_duration ? studentDoc.listen_duration : null,
    //     //   organizationKey: studentDoc.organizationKey,
    //     //   read_duration: studentDoc.read_duration,
    //     //   quiz_completed: studentDoc.quiz_completed,
    //     //   total_audio_books: studentDoc.total_audio_books,
    //     //   total_books: studentDoc.total_books,
    //     //   word_reads: studentDoc.word_reads,

    //     // }
    //     // historyDoc.doc(batchData.key).set(data, { merge: true })
    //     console.log('done');
    //   }
    // });
    this.loading = false;

  }

  async fetchSchoolStudent(school) {
    this.loading = true;
    const student = pushToArray(await this.ds.getStudent(school).get().toPromise())


    for await (const [index, item] of student.entries()) {
      // const item = student[index];
      if (item && item.key) {
        const student = this.ds.collection('students').doc(item.key)
        student.update({ resetPassword: true, isReset: true })

        console.log('done', index)
      }
    }

    // student.forEach(item => {
    //   if (item && item.key) {
    //     this.ds.collection('students').doc(item.key).update({ resetPassword: false })
    //     console.log('done')
    //   }
    // });
    console.log('students', student)

    this.loading = false;

  }



  @action
  async ResolveBookData() {
    this.loading = true;
    const books = pushToArray(await this.ds.booksRef().get().toPromise())
    const data = books.filter((m: any) => !m.questions)
    // console.log('data', toJS(data));

    // data.forEach(e => {
    //   if (e && e.key) {
    //     const book = this.ds.collection('book_store_books').doc(e.key)
    //     book.update({ a_set_questions_to_null: true })
    //   }

    // });


    this.loading = false;

  }
}

